var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "modal-body" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4" }),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-primary btn-block m-btn m-btn--icon",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.restoreAction.apply(null, arguments)
                }
              }
            },
            [
              _c("span", [
                _c("i", { staticClass: "flaticon-tool" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm._f("capitalize")(_vm._f("translate")("restore")))
                  )
                ])
              ])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", id: "btn-cancel" },
          on: { click: _vm.resetForm }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("close"))) +
              "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-417c4806", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417c4806","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/configuration/Restore.vue
// module id = 469
// module chunks = 0 1 71 164